<template>
    <div class="logistics">
        <navs></navs>
       <div class="about">
            <p class="bigTitle">智慧物流服务</p>
            <p class="smallTitle">SUPPLY CHAIN FINANCE</p>
        </div>

          <!--数据采集-->
        <div class="servers">
           <div class="titles">门到门服务，一站式满足客户运输需求</div>
           <p class="collectSub">
               应用“承运通”和“携船网”两大货运平台，结合物流大数据资源调度优势，精准、快速匹配对应船舶、车辆，承接水路、道路货物运输业务
            </p>
            <div class="collectImg"></div>
        </div>
          <!--运费竟价-->
        <div class="price">
           <div class="titles">运费竞价</div>
           <p class="collectSub">
               货主发单，承运人报价，自主选择最优承运人，彻底打破原有的“熟人交易”与“区域化市场壁垒”， 把运费定价权交还给市场，从而使物流价格合理透明，极大限度地降低货运成本
            </p>
            <div class="collectImg"></div>
        </div>

        <foot></foot>
        <rightC></rightC>
    </div>
</template>
<script>
import navs from '@/components/nav/head';
import foot from '@/components/nav/footer';
import rightC from '@/components/nav/rightFloat'
export default {
    name:'logistics',
    data(){
        return{
          current: 0
        }
    },
    components:{
     navs,foot,rightC
    },
    created(){

    }
}
</script>
<style lang='less' rel='stylesheet/less' >
   @rem:16rem;
   @col-f:#fff;
    .about{
       width: 100%;
       height: 160/@rem;
       background: url('../assets/zhi-b.png');
       background-repeat: no-repeat;
       background-position: center center;
       background-size: ceil(100%) ceil(100%);
       align-items: center;
       p{
           text-align: center;
           color: @col-f;
           font-size: 22/@rem;
           padding-top: 48/@rem;
           margin: 0;
           font-weight: 400;
       }
       .smallTitle{
           text-align: center;
           color: @col-f;
           font-size: 10/@rem;
           padding-top:10/@rem;
           font-weight: 300;

       }
   }
   .starsBox{
       width: 100%;
       height: 428/@rem;
       background: #020E39;
        text-align: center;
       .starTitle{
           padding-top: 30/@rem;
            font-size: 18/@rem;
             text-align: center;
             color:  @col-f;
            font-weight: 300;
       }
       .beiIntro{
           font-size: 10/@rem;
            color:  @col-f;
            padding-left: 19/@rem;
            padding-right:19/@rem;
            font-weight: 300;
         text-align: left;
            line-height: 20/@rem
       }
       .starsImg{
           width: 100%;
           height: 228/@rem;
            background: url('../assets/bei-b.png');
            background-repeat: no-repeat;
            background-position: center bottom;
            background-size: 290/@rem 210/@rem;
       }
   }


  .servers{
       padding: 22/@rem 16/@rem;
    .titles{
       font-size: 16/@rem;
       text-align: center;
       color:  #333;
       font-weight: 500;
  }
      .collectSub{
          font-size: 10/@rem;
          color: #666;
        //   text-align: justify;
        //   text-align-last: center;
        text-align: center;
          line-height: 16/@rem;

      }
      .collectImg{
            width: 100%;
            height: 148/@rem;
            background: url('../assets/zhi-1.png');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 260/@rem 128/@rem;
      }

  }
  .price{
       padding: 22/@rem 16/@rem;
       background:rgba(248,249,250,1);
    .titles{
       font-size: 16/@rem;
       text-align: center;
       color:  #333;
       font-weight: 500;
  }
      .collectSub{
          font-size: 10/@rem;
          color: #666;
        //    text-align: justify;
        //   text-align-last: center;
        text-align: center;
          line-height: 16/@rem;

      }
      .collectImg{
            width: 100%;
            height: 148/@rem;
            background: url('../assets/zhi-2.png');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 270/@rem 138/@rem;
      }
  }

  .footer{
      margin-top: 0
  }
</style>



// WEBPACK FOOTER //
// src/components/logistics.vue